import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { prettyDOM } from '@testing-library/react';

let apiUrl = 'http://localhost:9000/api/v1';

console.log(`env: ${process.env.NODE_ENV}`);
if(process.env.NODE_ENV === 'production') {
    apiUrl = process.env.REACT_APP_REST_URL + '/api/v1';
}

const httpClient = fetchUtils.fetchJson;

const pkMap = {
    firmwares: 'firmwareId',
    hydrant: 'deviceId',
    jobs: 'jobId',
};

export default {
    getList: (resource, params) => {
        console.log(`url: ${apiUrl}`);
        console.log(`DataProvider.getList - ${resource}`);
        const { page, perPage } = params.pagination;
        let { field, order } = params.sort;
        field = field === 'id'? pkMap[resource] : field;
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            // filter: JSON.stringify(params.filter),
            // sort: JSON.stringify(['firmwareId', 'ASC']),
        };
        
        resource = resource === "jobs"? "firmwares/jobs" : resource; 
        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`); 

        return httpClient(url, {headers})
            .then(({ json }) => {
                console.log(json);
                return {
                    data: json.data,
                    total: json.count,
                }
            });
    },

    getOne: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
            data: json,
        })),

    getMany: (resource, params) => {
        console.log(`DataProvider.getMany - ${resource}`);
        
        const query = {
            filter: JSON.stringify({ [pkMap[resource]]: params.ids }),
        };

        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);     

        const url = `${apiUrl}/${resource}?${stringify(query)}`;
        return httpClient(url, {headers}).then(({ json }) => ({ data: json.data }));
    },

    getManyReference: (resource, params) => {
        console.log(`DataProvider.getManyReference - ${resource}`);

        const { page, perPage } = params.pagination;
        var { field, order } = params.sort;
        field = field === 'id'? pkMap[resource] : field;        
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify({
                ...params.filter,
                [params.target]: params.id,
            }),
        };
        console.log(query);
        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        return httpClient(url).then(({ headers, json }) => ({
            data: json,
            total: parseInt(headers.get('content-range').split('/').pop(), 10),
        }));
    },

    update: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json })),

    updateMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'PUT',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },

    create: (resource, params) =>{
        console.log(`DataProvider.create - ${resource}`);
        console.log(params);
        const token = localStorage.getItem('token');        
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`); 

        if(resource === 'firmwares'){
            const file = params.data.files.rawFile;
            const fd = new FormData();
            fd.append('description', params.data.description || '');
            fd.append('file', file);
            return httpClient(`${apiUrl}/${resource}`, {
                method: 'POST',
                body: fd,
                headers
            }).then((json) => {
                console.log(JSON.stringify(json));
                return { data: { ...params.data, id: json.firmwareId } };
            });
        } else {
            const data = params.data;
            if(resource === "jobs") {
                data.deviceIds = data.deviceIds.toString().split(',');
                // data.deviceIds = JSON.parse("[" + data.deviceIds + "]");       
                // data.deviceIds = data.deviceIds.map( (i) => i.toString());
            }
            resource = resource === "jobs"? "firmwares/jobs" : resource;
            return httpClient(`${apiUrl}/${resource}`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers,
            }).then(({ json }) => ({
                data: { ...params.data, id: json.id },
            }));
        }
        
    },

    delete: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'DELETE',
        }).then(({ json }) => ({ data: json })),

    deleteMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids}),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'DELETE',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },
};